import protocolRelative from './protocol-relative.js';
import trusted from './trusted.js';

export default angular.module('cui.filters', [])
  .filter('protocolRelative', protocolRelative)
  .filter('trusted', trusted)
;



// WEBPACK FOOTER //
// ./source/client/filters/index.js